(function () {
	'use strict';

	angular
		.module('wizard-english-test', [
			'ngSanitize',
			'ui.router',
			'ngMask',
			'angularValidator',
			'19degrees.ngSweetAlert2',
			'ui.select',
			'timer',
			'flow',
			'ui.utils.masks',
			'ui.swiper',
			'smart-table',
			'angularXml2json',
			'ngCookies',

			'wizard-english-test.configs',
			'wizard-english-test.constants',
			'wizard-english-test.directives',
			'wizard-english-test.routes',
			'wizard-english-test.services'
		])
		.run(run);

	/** @ngInject */
	function run(HelperService, $trace, $transitions, $rootScope, $cookies, $state, $window) {
		$trace.enable(1, 5);

		HelperService.handleOnRun();

		$transitions.onEnter({}, $transition => {
			return HelperService.handleStateChangeStart($transition);
		});

		$transitions.onSuccess({}, $transition => {
			$rootScope.pageTitle = `${$transition.to().title} | Teste seu Inglês | Wizard`;
			$rootScope.currentState = $transition.to().name;
			$rootScope.isInternal = ($transition.to().name == "app.home") ? false : true;

			$('#login-modal').modal('hide')

			HelperService.handleStateChangeSuccess($transition);
		});

		$transitions.onError({}, ($transition, error) => {
			HelperService.handleStateChangeError(error);
		});

		$window.onload = () => {
			HelperService.handleViewContentLoaded();
		}

		$rootScope.$on('$viewContentLoaded', HelperService.handleViewContentLoaded);
	}
})();